import { useNavigate } from 'react-router-dom';
import ButtonPrimary from '../../../Components/subcomponents/ButtonPrimary';

function AdminPanel({ onViewEntries, onViewBallot, onViewResults, onRegJudge, onViewJudges, onManagePayments}) { // Add the onViewEntries prop
  const navigate = useNavigate();
  
  return (
    <div className='text-center'>
      <div>
        <h1 className="font-bold text-4xl py-8">Admin Panel</h1>
      </div>
      <div className='flex justify-center pb-3'>
        <ButtonPrimary onClick={onViewBallot}> {/* Call onViewEntries on click */}
          Start Ballot
        </ButtonPrimary>  
      </div>
      <div className='flex justify-center pb-3'>
        <ButtonPrimary onClick={onViewEntries}> {/* Call onViewEntries on click */}
          View Entries
        </ButtonPrimary>  
      </div>
      <div className='flex justify-center pb-3'>
        <ButtonPrimary onClick={onViewResults}> {/* Call onViewEntries on click */}
          View Results
        </ButtonPrimary>  
      </div>
      <div className='flex justify-center pb-3'>
        <ButtonPrimary onClick={onViewJudges}> {/* Call onViewEntries on click */}
          View Judges
        </ButtonPrimary>
      </div>
      <div className='flex justify-center pb-3'>
        <ButtonPrimary onClick={onManagePayments}>
          Manage Payments
        </ButtonPrimary>
      </div>
      <div className='flex justify-center pb-3'>
        <ButtonPrimary onClick={() => navigate('/registration?dayOfReg=true')}> {/* Call onViewEntries on click */}
          Day of Registration
        </ButtonPrimary>  
      </div>
      <div className='flex justify-center pb-3'>
        <ButtonPrimary onClick={() => navigate('/checkin')}> {/* Call onViewEntries on click */}
          Check-In
        </ButtonPrimary>  
      </div>

      
      <div className='flex justify-center pb-5'>
      </div>
      
    </div>
  );
}

export default AdminPanel;
